/**
 * Custom Store Location Section Script
 * Custom Element: <custom-store-location>
 */

class CustomStoreLocation extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.boundHandleThemeEditorLoad = this.handleThemeEditorLoad.bind(this);
    this.boundHandleThemeEditorSelect = this.handleThemeEditorSelect.bind(this);
  }

  connectedCallback() {
    // If animations are enabled, initialize scroll observer
    if (this.classList.contains('store-location--animate-on')) {
      this.initObserver();
    }

    // Shopify Theme Editor design mode listeners
    document.addEventListener('shopify:section:load', this.boundHandleThemeEditorLoad);
    document.addEventListener('shopify:section:select', this.boundHandleThemeEditorSelect);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    document.removeEventListener('shopify:section:load', this.boundHandleThemeEditorLoad);
    document.removeEventListener('shopify:section:select', this.boundHandleThemeEditorSelect);
  }

  initObserver() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-visible');
      return;
    }

    const options = {
      root: null, // viewport
      rootMargin: '0px 0px 80px 0px',
      threshold: 0.01 // Works reliably when this tall section enters a mobile viewport.
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.classList.add('is-visible');
          // Once animated, we don't need to observe anymore
          this.observer.unobserve(this);
        }
      });
    }, options);

    this.observer.observe(this);
  }

  handleThemeEditorLoad(event) {
    if (event.detail.sectionId === this.getSectionId()) {
      this.classList.remove('is-visible');
      if (this.classList.contains('store-location--animate-on')) {
        if (this.observer) {
          this.observer.disconnect();
        }
        this.initObserver();
      } else {
        this.classList.add('is-visible');
      }
    }
  }

  handleThemeEditorSelect(event) {
    if (event.detail.sectionId === this.getSectionId()) {
      this.classList.add('is-visible');
    }
  }

  getSectionId() {
    const section = this.closest('.shopify-section');
    if (section && section.id) {
      return section.id.replace('shopify-section-', '');
    }
    return '';
  }
}

// Define custom element if not already defined
if (!customElements.get('custom-store-location')) {
  customElements.define('custom-store-location', CustomStoreLocation);
}
